import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { reAuthenticateLocationAction } from './location.actions';
import { ILocationFeature } from './location.feature.state';
import { getFailures, getIsLoading, getLocationGuid, getLocationName } from './location.selectors';

@Injectable()
export class LocationFacade {
  public isLoading$ = this.store.select(getIsLoading);
  public failures$ = this.store.select(getFailures);
  public locationName$ = this.store.select(getLocationName);
  public locationGuid$ = this.store.select(getLocationGuid);

  constructor(private store: Store<ILocationFeature>) {}

  public reAuthenticateLocation(): void {
    this.store.dispatch(reAuthenticateLocationAction());
  }
}
